import { render, staticRenderFns } from "./topicConfig.vue?vue&type=template&id=5d044bc5&"
import script from "./topicConfig.vue?vue&type=script&lang=js&"
export * from "./topicConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports